import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Separator } from '../ui/separator';
import {
  HomeIcon,
  ShoppingBagIcon,
  ArrowRightOnRectangleIcon,
  UserCircleIcon,
  SparklesIcon,
  Cog6ToothIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';
import { cn } from '../../lib/utils';

const SidebarNew = ({ closeSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleLinkClick = () => {
    if (closeSidebar) {
      closeSidebar();
    }
  };

  const navItems = [
    {
      path: '/',
      icon: HomeIcon,
      label: 'داشبورد',
      badge: null
    },
    {
      path: '/products',
      icon: ShoppingBagIcon,
      label: 'محصولات',
      badge: null
    },
    // فقط کاربر ادمین این تب را می‌بیند
    ...(user.is_admin ? [{
      path: '/admin',
      icon: ShieldCheckIcon,
      label: 'پنل مدیریت',
      badge: 'مدیر'
    }] : []),
    {
      path: '/settings',
      icon: Cog6ToothIcon,
      label: 'تنظیمات',
      badge: null
    },
    {
      path: '/help',
      icon: SparklesIcon,
      label: 'راهنما',
      badge: null
    }
  ];

  return (
    <div
      className="h-full flex flex-col bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900"
      style={{ height: '100vh', overflow: 'hidden' }}
    >
      {/* Header با gradient */}
      <div className="flex items-center justify-center h-16 bg-gradient-to-r from-purple-600 to-blue-600 flex-shrink-0 shadow-lg">
        <h1 className="text-white text-2xl font-bold tracking-tight">رقیب‌سنج</h1>
      </div>

      {/* Navigation با shadcn styling */}
      <nav
        className="flex-1 overflow-y-auto px-3 py-6 space-y-2"
        style={{ flexGrow: 1, overflowY: 'auto' }}
      >
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={handleLinkClick}
              className={cn(
                "flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-200 group",
                isActive
                  ? "bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg"
                  : "text-slate-300 hover:bg-slate-700/50 hover:text-white"
              )}
            >
              <div className="flex items-center gap-3">
                <Icon
                  className={cn(
                    "h-5 w-5 transition-transform duration-200",
                    isActive ? "scale-110" : "group-hover:scale-110"
                  )}
                />
                <span className="font-medium">{item.label}</span>
              </div>
              {item.badge && (
                <Badge
                  variant={isActive ? "secondary" : "outline"}
                  className="text-xs"
                >
                  {item.badge}
                </Badge>
              )}
            </Link>
          );
        })}
      </nav>

      <Separator className="bg-slate-700" />

      {/* User Section با Card */}
      <div className="p-4 flex-shrink-0">
        <Card className="bg-slate-800 border-slate-700 p-4 mb-3">
          <div className="flex items-center gap-3 mb-3">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full opacity-75 blur-sm"></div>
              <UserCircleIcon className="relative h-10 w-10 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-white truncate">
                {user.name || 'کاربر'}
              </p>
              <p className="text-xs text-slate-400 truncate">
                {user.vendor_name || 'فروشنده'}
              </p>
            </div>
          </div>

          <button
            onClick={handleLogout}
            className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-lg transition-all duration-200 font-medium text-sm shadow-lg hover:shadow-xl"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5" />
            <span>خروج از حساب</span>
          </button>
        </Card>

        {/* Footer Badge */}
        <div className="text-center">
          <Badge variant="outline" className="text-xs text-slate-400 border-slate-700">
            نسخه 2.0
          </Badge>
        </div>
      </div>
    </div>
  );
};

export default SidebarNew;
